import type { ICurrentWindowStore } from "./ICurrentWindowStore";
import { type ILocalStorage, WindowLocalStorage } from "./local-storage/LocalStorage";
import { computed, makeObservable } from "mobx";

export class DefaultCurrentWindowStore implements ICurrentWindowStore {
    constructor() {
        makeObservable(this);
    }

    @computed
    public get currentWindow(): Window {
        return window;
    }

    @computed
    public get localStorage(): ILocalStorage {
        return new WindowLocalStorage(this.currentWindow);
    }

    @computed
    public get devicePixelRatio() {
        return this.currentWindow.devicePixelRatio || 1;
    }
}
